import React from 'react';
import tpl from '../templates/salary-project';
import BaseNewCardView from '../../../../Cards/views/BaseNewCardView';

export default class extends BaseNewCardView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            tab: 'entrepreneurs'
        };
    }

    static displayName = 'Business.SalaryProject';
}
